<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5c-0.48,0-0.95-0.48-1.9-1.43l-6.67-6.67c-1.9-1.91-1.9-1.91,0-3.81l6.67-6.67c1.9-1.91,1.9-1.91,3.81,0l6.67,6.67
	c1.9,1.9,1.9,1.9,0,3.81l-6.67,6.67C1.45,802.02,0.98,802.5,0.5,802.5L0.5,802.5z M2.74,795.36c1.17,0,2.04-0.71,2.67-1.38
	s1.11-1.39,1.48-1.76l-1.34-1.35c-0.59,0.59-1.05,1.3-1.53,1.82c-0.48,0.52-0.87,0.77-1.27,0.77c-0.01,0-0.19-0.05-0.48-0.33
	c-0.29-0.28-0.64-0.72-1-1.2c-0.37-0.48-0.75-0.98-1.2-1.41c-0.45-0.43-1.02-0.87-1.8-0.87c-1.17,0-2.04,0.71-2.67,1.38
	c-0.63,0.67-1.12,1.39-1.48,1.76l1.35,1.35c0.59-0.59,1.05-1.3,1.53-1.81c0.48-0.52,0.88-0.77,1.27-0.77c0.01,0,0.19,0.05,0.48,0.33
	c0.29,0.28,0.64,0.73,1,1.2c0.36,0.48,0.74,0.99,1.2,1.42C1.39,794.93,1.96,795.36,2.74,795.36L2.74,795.36z"/>
</svg>

</template>